
export const DIALOG_CONFIRMATION_HISTORY_TITLE = "Вы действительно хотите удалить историю изменений?"

export const DIALOG_CONFIRMATION_HISTORY_CONTENT = "Обратите внимание, данное действие необратимо и восстановить историю вы не сможете."

export const DIALOG_CONFIRMATION_HISTORY_OK_BUTTON = "Удалить"

export const DIALOG_CONFIRMATION_HISTORY_CANCEL_BUTTON = "Отмена"
